module.exports = __webpack_public_path__ + "img/map_1791445054902_92400.57fbe50d.jpg";